import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { LeaderCriteriaResponse } from "~pages/LeaderCriteria/types/leaderCriteria.ts";
import type { CreateLeaderCriteriaModel } from "~pages/LeaderCriteria/types/leaderCriteriaModel.ts";

export const useCreateLeaderCriteria = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<LeaderCriteriaResponse, Error, CreateLeaderCriteriaModel>({
    mutationFn: async (body) =>
      await request<LeaderCriteriaResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria`, {
        method: "POST",
        body,
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "leaders.qualification.create.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["leaderCriteria", sport, organizationId] });
    },
  });
};
